import Entity from '../Entity';

import ImageUrlHelper, {Options} from '../../helpers/ImageUrlHelper';

export default class ActorHairStyle implements Entity {
  constructor(
    public id: number,
    public actorId: number,
    public name: string,
    public colorPatternId: number,
    public colorPatternName: string,
    public originalImageUrl: string,
    public noHairColor: boolean,
  ) {}

  public getImageUrl(options: Options): string {
    return ImageUrlHelper.getImageUrl(this.originalImageUrl, options);
  }

  public getHalfImageUrl(): string {
    return ImageUrlHelper.getHalfImageUrl(this.originalImageUrl);
  }

  public getOneThirdImageUrl(): string {
    return ImageUrlHelper.getOneThirdImageUrl(this.originalImageUrl);
  }

  public getLabel(): string {
    return this.name;
  }
}
